import { tModalName, tModalsUnion } from "../../interfaces/interfaces";
import { tDispatch } from "../store";
import { eModalsActionTypes } from "./modalsTypes";

export const clearModalsState = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eModalsActionTypes.CLEAR_STATE,
		})
	}
}

export const openNewModal = (modal: tModalsUnion) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eModalsActionTypes.OPEN_NEW_MODAL,
			payload: modal
		})
	}
}

export const closeModal = (name: tModalName, id?: number) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eModalsActionTypes.CLOSE_MODAL,
			payload: {name, id}
		})
	}
}